<template>
    <span class="indicator-item">
        <figure v-if="averageMood === AWESOME_MOOD">
            <div class="emoji emoji--haha">
                <div class="emoji__face">
                    <div class="emoji__eyes"></div>
                    <div class="emoji__mouth">
                        <div class="emoji__tongue"></div>
                    </div>
                </div>
            </div>

            <figcaption>{{ __('[mood] Great') }}</figcaption>
        </figure>

        <figure v-else-if="averageMood === GREAT_MOOD">
            <div class="emoji emoji--yay">
                <div class="emoji__face">
                    <div class="emoji__eyebrows"></div>
                    <div class="emoji__mouth"></div>
                </div>
            </div>

            <figcaption>{{ __('[mood] Good') }}</figcaption>
        </figure>

        <figure v-else-if="averageMood === GOOD_MOOD">
            <div class="emoji emoji--disapointed">
                <div class="emoji__face">
                    <div class="emoji__eyes"></div>
                    <div class="emoji__mouth"></div>
                </div>
            </div>

            <figcaption>{{ __('OK') }}</figcaption>
        </figure>

        <figure v-else-if="averageMood === SO_SO_MOOD">
            <div class="emoji emoji--sad">
                <div class="emoji__face">
                    <div class="emoji__eyes no-tears"></div>
                    <div class="emoji__mouth"></div>
                </div>
            </div>

            <figcaption>{{ __('Not great') }}</figcaption>
        </figure>

        <figure v-else-if="averageMood === BAD_MOOD">
            <div class="emoji emoji--sad tears">
                <div class="emoji__face">
                    <div class="emoji__eyebrows"></div>
                    <div class="emoji__eyes"></div>
                    <div class="emoji__mouth"></div>
                </div>
            </div>

            <figcaption>{{ __('[mood] Bad') }}</figcaption>
        </figure>
        <template v-else>
            -
        </template>
    </span>
</template>

<script>
export default {
    props: {
        averageMood: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            AWESOME_MOOD: 4,
            GREAT_MOOD: 3,
            GOOD_MOOD: 2,
            SO_SO_MOOD: 1,
            BAD_MOOD: 0
        }
    }
}
</script>
